import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { WrapperWithOverlayHook } from "app/pages/sales-intelligence/common-components/overlay-hook";

import { useGetTrialTableHookProps } from "../../hooks/useGetTrialTableHookProps";

interface IProps {
    isTrial: boolean;
    rowHeight: number;
    children: ReactElement;
}

export const CompetitiveSWReactTableWrapper = ({ isTrial, rowHeight, children }: IProps): ReactElement => {
    const { overlayHookProps } = useGetTrialTableHookProps(rowHeight);

    if (!isTrial) {
        return children;
    }

    const handleGetLastRow = (wrapper: HTMLDivElement) => {
        const content = wrapper.querySelectorAll(".swReactTable-scrollable");

        if (!content || !content[content.length - 1]) {
            return;
        }

        const htmlColumns = content[content.length - 1].querySelectorAll(".swReactTable-column");

        if (!htmlColumns || !htmlColumns[0]) {
            return;
        }

        const htmlCells = htmlColumns[0].querySelectorAll(".swReactTableCell");

        if (!htmlCells || !htmlCells[htmlCells.length - 1]) {
            return;
        }

        return htmlCells[htmlCells.length - 1];
    };

    return (
        <WrapperWithOverlayHook
            {...overlayHookProps}
            trackingEventName="competitors hook"
            title={translate("si.company-analysis.competitors.trial-overlay-hook.title")}
            subTitle={translate("si.company-analysis.competitors.trial-overlay-hook.subtitle")}
            getLastRow={handleGetLastRow}
        >
            {children}
        </WrapperWithOverlayHook>
    );
};
